import { render, staticRenderFns } from "./HmBaseTransferNew.vue?vue&type=template&id=fb435030&scoped=true&"
import script from "./HmBaseTransferNew.vue?vue&type=script&lang=js&"
export * from "./HmBaseTransferNew.vue?vue&type=script&lang=js&"
import style0 from "./HmBaseTransferNew.vue?vue&type=style&index=0&id=fb435030&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb435030",
  null
  
)

component.options.__file = "HmBaseTransferNew.vue"
export default component.exports